import React from "react";
import { Typography, Box, Card, CardContent, Grid, Button } from "@mui/material";
import "./health.css";

const Health = ({ nextStep, prevStep }) => {
  return (
    <Box className='health-container'>
      <Box className='left-flower-character'>
        <img src='./CYPImages/WormisRainbow.png' alt='left-flower character' className='left-flower-character-image' />
      </Box>
      <Box className='right-flower-character'>
        <img
          src='./CYPImages/dentistholdingbigteeth.png'
          alt='right-flower character'
          className='right-flower-character-image'
        />
      </Box>
      <Box className='health-info-container'>
        {/* Title */}
        <Typography variant='h4' className='health-title' align='center' gutterBottom>
          Health
        </Typography>
        {/* Subtitle */}
        <Typography variant='body1' align='center' className='subtitle' gutterBottom>
          When you move to Little Norway you will be registered with a doctor, <br />
          dentist and Optician.
        </Typography>

        {/* Image Section */}
        <Box>
          {/* First two images in a single line without space */}
          <Grid container>
            <Grid item xs={4} sm={4} lg={4}>
              <img src='./CYPImages/teeth.png' alt='Bullying illustration' className='health-image' />
            </Grid>

            <Grid item xs={4} sm={4} lg={4}>
              <img src='./CYPImages/doctorchild.png' alt='Bullying illustration' className='health-image' />
            </Grid>
            <Grid item xs={4} sm={4} lg={4}>
              <img src='./CYPImages/search.png' alt='Bullying illustration' className='health-image' />
            </Grid>
          </Grid>
        </Box>

        {/* Subtitle */}
        <Typography variant='body1' align='center' className='subtitle' gutterBottom>
          The Adults in the home will help you with this and make sure you <br />
          have regular checkups. You will also have to go for any health <br /> assessment required while you stay in
          Little Norway.
        </Typography>

        {/* Health Information Card */}
        <Card className='health-card' sx={{ backgroundColor: "#F8F3FD" }}>
          <CardContent>
            <Typography variant='body1' className='card-text'>
              To make sure you are healthy we will need to find out <br /> about your health history and keep a record
              of this.
            </Typography>
            <br />
            <Typography variant='body1' className='card-text'>
              We will keep any medication you take in a locked <br /> cabinet which will be administered by staff as at
              when <br />
              required.
            </Typography>
            <br />
            <Typography variant='body1' className='card-text'>
              We will also help and provide advice and information <br /> on health matters such as smoking,
              relationships, <br />
              drugs and any related concerns observed.
            </Typography>
          </CardContent>
        </Card>
        <Grid container justifyContent='space-between' alignItems='center' mt={2} ml={2}>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={prevStep}>
              Previous
            </Button>
          </Grid>
          <Grid item>
            <Button type='button' variant='contained' color='primary' onClick={nextStep}>
              Next
            </Button>
          </Grid>
        </Grid>
      </Box>
      {/* Doctor Image */}
      <Box className='doctor-image-container'>
        <img src='./CYPImages/doctor.png' alt='Doctor illustration' className='doctor-image' />
      </Box>
    </Box>
  );
};

export default Health;
